import { render, staticRenderFns } from "./resource-card.vue?vue&type=template&id=097b5f0a"
import script from "./resource-card.vue?vue&type=script&lang=js"
export * from "./resource-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports